<template>
  <div class="loader" :class="{'loader_text_small': textSmall}">
    <div class="loader__caption">
      <slot/>
      <span class="loader__dot loader__dot_1">.</span><span class="loader__dot loader__dot_2">.</span><span class="loader__dot loader__dot_3">.</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Loader',
    props: {
      textSmall: {
        type: Boolean,
        required: false
      }
    }
  }
</script>
